// src/firebase/firestore.js
import { collection, doc, getDocs, getDoc, addDoc, updateDoc, deleteDoc, setDoc, orderBy, query } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { db, storage } from "./config";

export async function uploadImage(file, folder = "images") {
  const filename = `${folder}/${Date.now()}_${file.name}`;
  const storageRef = ref(storage, filename);
  await uploadBytes(storageRef, file);
  return { url: await getDownloadURL(storageRef), path: filename };
}

// Site settings
export async function getSiteSettings() {
  const snap = await getDoc(doc(db, "site", "settings"));
  return snap.exists() ? snap.data() : null;
}
export async function saveSiteSettings(data) { await setDoc(doc(db, "site", "settings"), data); }

// Hero
export async function getHero() {
  const snap = await getDoc(doc(db, "site", "hero"));
  return snap.exists() ? snap.data() : null;
}
export async function saveHero(data) { await setDoc(doc(db, "site", "hero"), data); }

// About
export async function getAbout() {
  const snap = await getDoc(doc(db, "site", "about"));
  return snap.exists() ? snap.data() : null;
}
export async function saveAbout(data) { await setDoc(doc(db, "site", "about"), data); }

// Programs
export async function getPrograms() {
  const q = query(collection(db, "programs"), orderBy("order", "asc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}
export async function addProgram(data) { return await addDoc(collection(db, "programs"), { ...data, order: Date.now() }); }
export async function updateProgram(id, data) { await updateDoc(doc(db, "programs", id), data); }
export async function deleteProgram(id) { await deleteDoc(doc(db, "programs", id)); }

// Team
export async function getTeam() {
  const q = query(collection(db, "team"), orderBy("order", "asc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}
export async function addTeamMember(data) { return await addDoc(collection(db, "team"), { ...data, order: Date.now() }); }
export async function updateTeamMember(id, data) { await updateDoc(doc(db, "team", id), data); }
export async function deleteTeamMember(id) { await deleteDoc(doc(db, "team", id)); }

// Board
export async function getBoard() {
  const q = query(collection(db, "board"), orderBy("order", "asc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}
export async function addBoardMember(data) { return await addDoc(collection(db, "board"), { ...data, order: Date.now() }); }
export async function updateBoardMember(id, data) { await updateDoc(doc(db, "board", id), data); }
export async function deleteBoardMember(id) { await deleteDoc(doc(db, "board", id)); }

// Stories
export async function getStories() {
  const q = query(collection(db, "stories"), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}
export async function addStory(data) { return await addDoc(collection(db, "stories"), { ...data, createdAt: Date.now() }); }
export async function updateStory(id, data) { await updateDoc(doc(db, "stories", id), data); }
export async function deleteStory(id) { await deleteDoc(doc(db, "stories", id)); }

// Jobs
export async function getJobs() {
  const q = query(collection(db, "jobs"), orderBy("postedAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}
export async function addJob(data) { return await addDoc(collection(db, "jobs"), { ...data, postedAt: Date.now() }); }
export async function updateJob(id, data) { await updateDoc(doc(db, "jobs", id), data); }
export async function deleteJob(id) { await deleteDoc(doc(db, "jobs", id)); }

// Announcements
export async function getAnnouncements() {
  const q = query(collection(db, "announcements"), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}
export async function addAnnouncement(data) { return await addDoc(collection(db, "announcements"), { ...data, createdAt: Date.now() }); }
export async function updateAnnouncement(id, data) { await updateDoc(doc(db, "announcements", id), data); }
export async function deleteAnnouncement(id) { await deleteDoc(doc(db, "announcements", id)); }

// Videos
export async function getVideos() {
  const snap = await getDoc(doc(db, "site", "videos"));
  return snap.exists() ? snap.data() : null;
}
export async function saveVideos(data) { await setDoc(doc(db, "site", "videos"), data); }
